// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_5c256e66"};